import NextVoSpoolRewards from './NextVoSpoolRewards';
import SpoolPerVoSpool from './SpoolPerVoSpool';

const VoSpoolEpochRewards = () => {
    return (
        <div className='vospool-epoch-rewards'>
            <NextVoSpoolRewards />
            <SpoolPerVoSpool />
        </div>
    );
};

export default VoSpoolEpochRewards;
